import { ROBOT_META_INSTRUCTION, SCHEMA_ITEM_PROP } from '../../constants/seo';
import COPYRIGHT_YEAR from '../../constants/copyrightYear';
import { EXPONDO_LOGO_DARK_PATH } from '../../constants/expondoLogoPath';
import { APP_VERSION_META_TAG_NAME, APP_VERSION_META_TAG_HID } from '../../constants/appVersion';
import type { MetaTag } from './types/MetaTag';
import type { OGMetaTag } from './types/OGMetaTag';

const DEFAULT_IMAGE_PATH = EXPONDO_LOGO_DARK_PATH;

export function generateMetaDescription(input: string): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.DESCRIPTION,
    name: SCHEMA_ITEM_PROP.DESCRIPTION,
    content: input.toString(),
  };

}

export function generateMetaOGDescription(input: string): OGMetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.OGDESCRIPTION,
    property: SCHEMA_ITEM_PROP.OGDESCRIPTION,
    content: input,
  };

}
export function generateMetaRobots(isPageIndexed: boolean): MetaTag {

  return {
    hid: 'robots',
    name: 'robots',
    content: isPageIndexed ? 'index, follow' : 'noindex, nofollow',
  };

}

export function generateMetaCopyrightHolder(input: string): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.COPYRIGHT_HOLDER,
    name: SCHEMA_ITEM_PROP.COPYRIGHT_HOLDER,
    itemprop: SCHEMA_ITEM_PROP.COPYRIGHT_HOLDER,
    content: input,
  };

}

export function generateMetaCopyrightYear(): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.COPYRIGHT_YEAR,
    name: SCHEMA_ITEM_PROP.COPYRIGHT_YEAR,
    itemprop: SCHEMA_ITEM_PROP.COPYRIGHT_YEAR,
    content: COPYRIGHT_YEAR,
  };

}

export function generateMetaIsFamilyFriendly(): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.IS_FAMILY_FRIENDLY,
    name: SCHEMA_ITEM_PROP.IS_FAMILY_FRIENDLY,
    itemprop: SCHEMA_ITEM_PROP.IS_FAMILY_FRIENDLY,
    content: 'True',
  };

}

export function generateMetaExpondoImage(imagePath: Maybe<string>): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.IMAGE,
    name: SCHEMA_ITEM_PROP.IMAGE,
    itemprop: SCHEMA_ITEM_PROP.IMAGE,
    content: imagePath || DEFAULT_IMAGE_PATH,
  };

}

export function generateMetaExpondoOGImage(imagePath: Maybe<string>): OGMetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.OGIMAGE,
    property: SCHEMA_ITEM_PROP.OGIMAGE,
    content: imagePath || DEFAULT_IMAGE_PATH,
  };

}

export function generateMetaTitleName(input: string): MetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.NAME,
    name: SCHEMA_ITEM_PROP.NAME,
    itemprop: SCHEMA_ITEM_PROP.NAME,
    content: input,
  };

}

export function generateMetaOGTitle(input: string): OGMetaTag {

  return {
    hid: SCHEMA_ITEM_PROP.OGTITLE,
    property: SCHEMA_ITEM_PROP.OGTITLE,
    content: input,
  };

}

export function generateMetaAppVersion(versionTag: string): MetaTag {

  return {
    hid: APP_VERSION_META_TAG_HID,
    name: APP_VERSION_META_TAG_NAME,
    content: versionTag,
  };

}

export function setRobotsInstructionAsIndexed(inputText: string): string {

  return inputText.replace(
    ROBOT_META_INSTRUCTION.NOINDEX_NOFOLLOW,
    ROBOT_META_INSTRUCTION.INDEX_FOLLOW,
  );

}

export function setRobotsInstructionAsNotIndexed(inputText: string): string {

  return inputText.replace(
    ROBOT_META_INSTRUCTION.INDEX_FOLLOW,
    ROBOT_META_INSTRUCTION.NOINDEX_NOFOLLOW,
  );

}
